import { Continent, UpsertContinent } from '@/models/continent.model';
import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PaginationFilterRequest, PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";

export const getPagedContinents = async (input: PaginationFilterRequest): Promise<PagedResponseModel<Continent>> => {
  return await getReq(createUrl("a/Continent/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getContinentsLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedContinents(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })      
  );
};

export const getContinent = async (id: number): Promise<BaseResponseModel<Continent>> => {
  return await getReq(createUrl(`a/Continent/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertContinent = async (input: UpsertContinent): Promise<BaseResponseModel<Continent>> => {
  return await postReq(createUrl("a/Continent/Upsert"),
    input
  ).then((res: any) => res.data);
};
